import { render, staticRenderFns } from "./enewsEdit.vue?vue&type=template&id=61563369&scoped=true&lang=html&"
import script from "./enewsEdit.vue?vue&type=script&lang=js&"
export * from "./enewsEdit.vue?vue&type=script&lang=js&"
import style0 from "./enewsEdit.vue?vue&type=style&index=0&id=61563369&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61563369",
  null
  
)

export default component.exports